import Widget from "./Widget";
import sources from "../config/sources";
import { tmpl } from "../../templates/choroplethwidget.js";
import { formatChange, formatNumber } from "../helpers/formatters";

import { selectAll, select } from "d3-selection";
/**
 * Using http://datamaps.github.io/ for choropleths
 */
import Datamap from "datamaps";
import * as Worldtopo from "../config/worldtopo.json";

export default class Choropleth extends Widget {
  constructor(feed) {
    super();

    this.dataset = {};
    this.markers = [];

    if (!Object.prototype.hasOwnProperty.call(sources, feed)) {
      throw new Error(`Invalid feed: ${feed}`);
    }

    this.datasources = sources[feed];

    Datamap.prototype.worldTopo = Worldtopo;
    this.countries = Datamap.prototype.worldTopo.objects.world.geometries;
  }

  init(el) {
    const data = this.getData(
      DATA_URL + this.datasources["country"]["table"]["url"]
    );
    data.then((data) => {
      // we're only going to use the 10 top, so lets trim the rest
      data = data.slice(0, 10);

      let index = 1;
      data.forEach((item) => {
        let iso = item.alpha3,
          value = item.value;
        let countryIndex = this.countries.findIndex(function (country) {
          return country.id == iso;
        });

        // don't plot something where the country code is not known
        if (countryIndex == -1) {
          console.log("Unknown country code: " + iso);
          return;
        }

        this.dataset[iso] = {
          numberOfThings: value,
          fillColor: "#677692",
          change: item.change,
          rank: item.rank,
        };
        this.markers.push({
          key: index,
          country: this.countries[countryIndex].properties.name,
          count: item.value,
          change: item.change,
          radius: 8,
          latitude: item.latitude,
          longitude: item.longitude,
          label: item.rank,
        });
      });

      this.render(el);
    });
  }

  render(el) {
    this.div = document.createElement("div");
    this.div.classList.add("sh-widget", "sh-geo-widget", this._theme);
    this.setTemplate(tmpl);
    this.setTitle("Top 10 countries with the highest infection rates");
    el.replaceWith(this.div);

    const map = new Datamap({
      element: this.div.querySelector('[data-element="map"]'),
      projection: "mercator",
      fills: { defaultFill: "#3d5071" },
      data: this.dataset,
      geographyConfig: {
        borderColor: "#DEDEDE",
        borderWidth: 0,
        highlightBorderWidth: 0,
        highlightFillColor: "rgb(122, 135, 153)",

        popupTemplate: function (geo, data) {
          if (!data) {
            return;
          }

          // tooltip content
          return `<div class="sh-widget-tooltip">
                        <div class="sh-tooltip-header">${
                          geo.properties.name
                        }</div>
                        <div class="sh-tooltip-body">
                        <div class="sh-widget-tooltip-row"><div>Rank <span class="sh-tooltip-rank">${
                          data.rank
                        }</span></div> <div>Detections: <span class="number-sm">${formatNumber(
            data.numberOfThings
          )}</span></div></div>
          <div class="sh-widget-tooltip-row"><div>% change</div><div><span class="number">${formatChange(
            data.change
          )}</span></div></div>
      </div>`;
        },
      },
      bubblesConfig: {
        fills: { defaultFill: "#142741" },
        borderWidth: 0,
        highlightOnHover: false,
        fillOpacity: 0,
        exitDelay: 100,
        popupOnHover: true,
        popupTemplate: function (geo, data) {
          // tooltip content
          return `<div class="sh-widget-tooltip">
                        <div class="sh-tooltip-header">${data.country}</div>
                        <div class="sh-tooltip-body">
                        <div class="sh-widget-tooltip-row"><div>Rank <span class="sh-tooltip-rank">${
                          data.label
                        }</span></div> <div>Detections: <span class="number-sm">${formatNumber(
            data.count
          )}</span></div></div>
          <div class="sh-widget-tooltip-row"><div>% change</div><div><span class="number">${formatChange(
            data.change
          )}</span></div></div>
      </div>`;
        },
      },
    });

    map.bubbles(this.markers);

    map.addPlugin("bubbleLabels", this.handleBubbleLabels);
    map.bubbleLabels(this.markers, { labelColor: "#FFF", labelKey: "fillKey" });
    select(".bubbles").raise();

    this.clearLoading();
  }

  //standard plugin interface. Function takes 3 params - a layer ('<g>', data, and the options object)
  handleBubbleLabels(layer, data, options) {
    var self = this;
    options = options || {};

    selectAll(".datamaps-bubble").attr("data-info", function (datum) {
      //convert lat/lng into x/y
      var coords = self.latLngToXY(datum.latitude, datum.longitude);

      // add a replica of a bubble, this will be hidden behind the actual bubble
      layer
        .append("circle")
        .attr("r", 10)
        .attr("fill", "#eec216")
        .attr("cx", coords[0])
        .attr("cy", coords[1])
        .style("stroke-width", 0);

      layer
        .append("text")
        .attr("x", coords[0])
        .attr("y", coords[1] + 3)
        .style("font-size", (options.fontSize || 10) + "px")
        .style("font-family", options.fontFamily || "Arial")
        .style("font-weight", "bold")
        .style("fill", "#000")
        .style("text-anchor", "middle")
        .text(datum["label"]);
    });
  }
}
